// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeader_wrapper__q6iqV","searchBox":"PageHeader_searchBox__KNMgY"};